export const RECOMMENDATION_LIST_TYPE = {
  BASIC_LIST: 'basicList',
  THEMED_LIST: 'themedList',
  PHOTO_CAROUSEL: 'photoCarousel',
  FLYER_CAROUSEL: 'flyerCarousel',
  PHOTO_LIST: 'photoList',
  FEATURED_EVENT: 'featuredEvent',
};

export const RECOMMENDATION_LIST_THEME = {
  ZOMBIE_LEMON: 'zombieLemon',
  LOVE_IS_IN_THE_AIR: 'loveIsInTheAir',
  ST_PATRICK: 'stPatrick',
  VENTI_SPECTRUM_LIGHT: 'ventiSpectrumLight',
  VENTI_SPECTRUM_DARK: 'ventiSpectrumDark',
  VENTI_DEEP_PULSE: 'ventiDeepPulse',
  VENTI_AFTERGLOW: 'ventiAfterglow',
  MUNDO_MARINO: 'mundoMarino',
  NINE_TWELVE_EIGHTEEN: 'nineTwelveEighteen',
  SUNSET_FADE: 'sunsetFade',
  GOLDEN_HOUR: 'goldenHour',
  RUST: 'rust',
  TOXIC_WASTE: 'toxicWaste',
  TOUGH_GRASS: 'toughGrass',
  SPRITE: 'sprite',
  CYBERPUNK: 'cyberpunk',
  DREAMWAVE: 'dreamwave',
  BUBBALOO: 'bubbaloo',
  HELADO_TRICOLOR: 'heladoTricolor',
};

export const RECOMMENDATION_LIST_VISIBILITY = {
  ACTIVE: 'active',
  HIDDEN: 'hidden',
};

export const RECOMMENDATION_LIST_VISIBILITY_OPTIONS = [
  { value: RECOMMENDATION_LIST_VISIBILITY.ACTIVE, label: 'Activa' },
  { value: RECOMMENDATION_LIST_VISIBILITY.HIDDEN, label: 'Oculta' },
];

export const RECOMMENDATION_LIST_THEME_OPTIONS = [
  { value: RECOMMENDATION_LIST_THEME.ZOMBIE_LEMON, label: 'Zombie Lemon' },
  { value: RECOMMENDATION_LIST_THEME.LOVE_IS_IN_THE_AIR, label: 'Love is in the air' },
  { value: RECOMMENDATION_LIST_THEME.ST_PATRICK, label: 'St Patrick' },
  { value: RECOMMENDATION_LIST_THEME.VENTI_SPECTRUM_LIGHT, label: 'Venti Spectrum Light' },
  { value: RECOMMENDATION_LIST_THEME.VENTI_SPECTRUM_DARK, label: 'Venti Spectrum Dark' },
  { value: RECOMMENDATION_LIST_THEME.VENTI_DEEP_PULSE, label: 'Venti Deep Pulse' },
  { value: RECOMMENDATION_LIST_THEME.VENTI_AFTERGLOW, label: 'Venti Afterglow' },
  { value: RECOMMENDATION_LIST_THEME.MUNDO_MARINO, label: 'Mundo Marino' },
  { value: RECOMMENDATION_LIST_THEME.NINE_TWELVE_EIGHTEEN, label: '9-12-18' },
  { value: RECOMMENDATION_LIST_THEME.SUNSET_FADE, label: 'Sunset Fade' },
  { value: RECOMMENDATION_LIST_THEME.GOLDEN_HOUR, label: 'Golden Hour' },
  { value: RECOMMENDATION_LIST_THEME.RUST, label: 'Rust' },
  { value: RECOMMENDATION_LIST_THEME.TOXIC_WASTE, label: 'Toxic Waste' },
  { value: RECOMMENDATION_LIST_THEME.TOUGH_GRASS, label: 'Tough Grass' },
  { value: RECOMMENDATION_LIST_THEME.SPRITE, label: 'Sprite' },
  { value: RECOMMENDATION_LIST_THEME.CYBERPUNK, label: 'Cyberpunk' },
  { value: RECOMMENDATION_LIST_THEME.DREAMWAVE, label: 'Dreamwave' },
  { value: RECOMMENDATION_LIST_THEME.BUBBALOO, label: 'Bubbaloo' },
  { value: RECOMMENDATION_LIST_THEME.HELADO_TRICOLOR, label: 'Helado Tricolor' },
];

export const RECOMMENDATION_LIST_TYPE_OPTIONS = [
  { value: RECOMMENDATION_LIST_TYPE.BASIC_LIST, label: 'Lista básica' },
  { value: RECOMMENDATION_LIST_TYPE.PHOTO_LIST, label: 'Lista básica con foto' },
  { value: RECOMMENDATION_LIST_TYPE.THEMED_LIST, label: 'Lista temática' },
  { value: RECOMMENDATION_LIST_TYPE.PHOTO_CAROUSEL, label: 'Carrousel de fotos' },
  { value: RECOMMENDATION_LIST_TYPE.FLYER_CAROUSEL, label: 'Carrousel de flyers' },
  { value: RECOMMENDATION_LIST_TYPE.FEATURED_EVENT, label: 'Evento destacado' },
];

export const THEME_GRADIENTS = {
  [RECOMMENDATION_LIST_THEME.ZOMBIE_LEMON]:
    'linear-gradient(45deg, #A1E868 0%, #6A2B81 39%, #3F3B49 65%)',
  [RECOMMENDATION_LIST_THEME.LOVE_IS_IN_THE_AIR]:
    'linear-gradient(45deg, #F4E5E5 0%, #CF3D3D 39%, #A5000C 65%)',
  [RECOMMENDATION_LIST_THEME.ST_PATRICK]:
    'linear-gradient(45deg, #C2E5CF 0%, #449C6D 39%, #155A2B 65%)',
  [RECOMMENDATION_LIST_THEME.VENTI_SPECTRUM_LIGHT]:
    'linear-gradient(45deg, #FF5619 20%, #7D5BF6 55%, #D9D9D9 100%)',
  [RECOMMENDATION_LIST_THEME.VENTI_SPECTRUM_DARK]:
    'linear-gradient(45deg, #232323 0%, #7D5BF6 50%, #FF5619 90%)',
  [RECOMMENDATION_LIST_THEME.VENTI_DEEP_PULSE]:
    'linear-gradient(45deg, #26272B 10%, #5C2E91 40%, #7D5BF6 90%)',
  [RECOMMENDATION_LIST_THEME.VENTI_AFTERGLOW]:
    'linear-gradient(45deg, #FF55BA 15%, #FF5619 60%, #26272B 100%)',
  [RECOMMENDATION_LIST_THEME.MUNDO_MARINO]:
    'linear-gradient(45deg, #232323 0%, #50B9E8 36%, #7D5BF6 80%)',
  [RECOMMENDATION_LIST_THEME.NINE_TWELVE_EIGHTEEN]:
    'linear-gradient(45deg, #D3D3D3 0%, #505050 40%, #FF0101 85%)',
  [RECOMMENDATION_LIST_THEME.SUNSET_FADE]:
    'linear-gradient(45deg, #232323 10%, #FF5619 68%, #FFD180 100%)',
  [RECOMMENDATION_LIST_THEME.GOLDEN_HOUR]:
    'linear-gradient(45deg, #FFEEA8 0%, #FFB31A 35%, #FF6F61 85%)',
  [RECOMMENDATION_LIST_THEME.RUST]: 'linear-gradient(45deg, #232323 0%, #505050 40%, #FF5619 85%)',
  [RECOMMENDATION_LIST_THEME.TOXIC_WASTE]:
    'linear-gradient(45deg, #26272B 0%, #58E026 75%, #1E8952 100%)',
  [RECOMMENDATION_LIST_THEME.TOUGH_GRASS]:
    'linear-gradient(45deg, #FFEEE3 0%, #A7B634 30%, #5A6C0C 75%)',
  [RECOMMENDATION_LIST_THEME.SPRITE]:
    'linear-gradient(45deg, #5D951D 0%, #42B42D 35%, #CDEA15 95%)',
  [RECOMMENDATION_LIST_THEME.CYBERPUNK]:
    'linear-gradient(45deg, #26272B 12%, #FF55BA 65%, #7D5BF6 95%)',
  [RECOMMENDATION_LIST_THEME.DREAMWAVE]:
    'linear-gradient(45deg, #FED2E9 0%, #FF6F66 30%, #7D5BF6 76%)',
  [RECOMMENDATION_LIST_THEME.BUBBALOO]:
    'linear-gradient(45deg, #FFD1DF 0%, #FF8299 40%, #D025A8 75%)',
  [RECOMMENDATION_LIST_THEME.HELADO_TRICOLOR]:
    'linear-gradient(45deg, #F7F885 15%, #FF8D52 60%, #9ADDF4 75%)',
};
